<div
  *ngIf="orderSummary as orderSummary"
  class="order-summary-wrapper"
>
  <ng-container *ngrxLet="businessPlan$ as businessPlan">

    <!-- Table Header -->
    <section class="inline-flex w-full">
      <div class="flex-grow basis-2/5 w-2/5">
        <span class="mat-title !text-sub !mb-0 text-darkGray">Item</span>
      </div>
      <div
        *ngIf="businessPlan?.isPremium()"
        class="flex-grow basis-1/5 w-1/5 text-center"
      >
        <span class="mat-title !text-sub !mb-0 text-darkGray"
        >Rate ({{ summaryCurrency }})</span
        >
      </div>
      <div class="flex-grow basis-1/5 w-1/5 text-center">
        <span class="mat-title !text-sub !mb-0 text-darkGray">Quantity</span>
      </div>
      <div
        *ngIf="businessPlan?.isPremium()"
        class="flex-grow basis-1/5 w-1/5 text-center"
      >
        <span class="mat-title !text-sub !mb-0 text-darkGray"
        >Amount ({{ summaryCurrency }})</span
        >
      </div>
    </section>

    <mat-divider class="!my-4"></mat-divider>

    <!-- Main Items -->
    <section class="services-container">
      <div
        *ngFor="let item of items"
        class="service-item inline-flex w-full mb-2"
      >
        <div class="flex-grow basis-2/5 w-2/5">
          <p class="text-sub !mb-0">
            <span>{{ item.name }}</span>
            <span
              *ngIf="
                businessPlan?.isPremium() && item.isSubscription
              "
              class="italic text-darkGray opacity-80"
            >&nbsp;(billed
              {{ item.billingCycleLabel?.toLocaleLowerCase() }})</span
            >
          </p>
        </div>
        <div
          *ngIf="businessPlan?.isPremium()"
          class="flex-grow basis-1/5 w-1/5 text-center"
        >
          <span
            *ngIf="item.isContactToClient && item.rate === 0; else showServiceFee"
            class="!text-sub !mb-0"
          >-</span
          >
          <ng-template #showServiceFee>
            <span class="!text-sub !mb-0">{{ item.rate | number }}</span>
          </ng-template>
        </div>
        <div class="flex-grow basis-1/5 w-1/5 text-center">
          <span class="!text-sub !mb-0">{{ item.quantity }}</span>
        </div>
        <div
          *ngIf="businessPlan?.isPremium()"
          class="flex-grow basis-1/5 w-1/5 text-center"
        >
          <span
            *ngIf="item.isContactToClient && item.rate === 0; else showAmount"
            class="!text-sub !mb-0">
            You'll be contacted
          </span>
          <ng-template #showAmount>
            <span
              class="!text-sub !mb-0 break-words">
              {{ item.amount | number }}
            </span>
          </ng-template>
        </div>
      </div>

      <!-- Divider to separate main items from summary rows -->
      <mat-divider class="!my-4"></mat-divider>

      <!-- Summary Rows in the Same Table -->

      <ng-container *ngIf="businessPlan?.isPremium()">
        <!-- Subtotal Row -->
        <div class="service-item inline-flex w-full mb-2">
          <div class="flex-grow basis-2/5 w-2/5">
            <p class="!text-sub !mb-0 mat-title">Subtotal</p>
          </div>
          <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
          <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
          <div class="flex-grow basis-1/5 w-1/5 text-center">
            <span class="!text-sub !mb-0 break-words">
              <ng-container *ngIf="shouldShowPendingPricingSummary; else subtotalValue">
                N/A
              </ng-container>
              <ng-template #subtotalValue>
                {{
                  subtotalAmount | smartCurrency:summaryCurrency:'':'symbol':null:true
                }}
              </ng-template>
            </span>
          </div>
        </div>

        <!-- Promotion Discount Row (moved below Subtotal) -->
        <ng-container *ngIf="!isCheckoutMode && showPromotionDiscountRow">
          <div class="service-item inline-flex w-full mb-2">
            <div class="flex-grow basis-2/5 w-2/5">
              <p class="!text-sub !mb-0 mat-title">Promotion Discount</p>
            </div>
            <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center">
              <span class="!text-sub !mb-0 break-words">
                - {{ order?.discountAmount | smartCurrency:summaryCurrency }}
              </span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="isCheckoutMode && showPromotionDiscountRow">
          <div class="service-item inline-flex w-full mb-2">
            <div class="flex-grow basis-2/5 w-2/5">
              <p class="!text-sub !mb-0 mat-title">Promotion Discount</p>
            </div>
            <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center">
              <span class="!text-sub !mb-0 break-words">
                - {{ promotionDiscountAmount | smartCurrency:summaryCurrency }}
              </span>
            </div>
          </div>
        </ng-container>

        <!-- GST/VAT Row -->
        <div
          *ngIf="supportedCountry?.includeTax"
          class="service-item inline-flex w-full mb-2"
        >
          <div class="flex-grow basis-2/5 w-2/5" *ngIf="order">
            <p class="!text-sub !mb-0 mat-title">
              GST/VAT {{ supportedCountry?.taxRate }}%
            </p>
          </div>
          <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
          <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
          <div class="flex-grow basis-1/5 w-1/5 text-center" *ngIf="order">
            <span class="!text-sub !mb-0 break-words">
              {{
                taxAmount | smartCurrency:summaryCurrency:'N/A'
              }}
            </span>
          </div>
        </div>

        <!-- Official Fees Row -->
        <div class="service-item inline-flex w-full mb-2">
          <div class="flex-grow basis-2/5 w-2/5">
            <p class="!text-sub !mb-0 mat-title">Official fees</p>
          </div>
          <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
          <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
          <div class="flex-grow basis-1/5 w-1/5 text-center">
            <span class="!text-sub !mb-0 break-words">
              {{
                officialFeeAmount | smartCurrency:summaryCurrency:'N/A'
              }}
            </span>
          </div>
        </div>

        <ng-container *ngIf="order">
          <mat-divider class="!my-4"></mat-divider>

          <!-- Total Row -->
          <div class="service-item inline-flex w-full mb-2">
            <div class="flex-grow basis-2/5 w-2/5">
              <p class="!text-sub !mb-0 mat-title">Total</p>
            </div>
            <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center">
            <span class="!text-sub !mb-0 break-words mat-title">
              <ng-container *ngIf="shouldShowPendingPricingSummary; else totalValue">
                N/A
              </ng-container>
              <ng-template #totalValue>
                {{
                  totalAmount | smartCurrency:summaryCurrency:'':'symbol':null:true
                }}
              </ng-template>
            </span>
            </div>
          </div>

          <!-- Equal to USD Row -->
          <div *ngIf="summaryCurrency !== 'USD' && equalToUsdAmount !== null && !shouldShowPendingPricingSummary" class="service-item inline-flex w-full mb-2">
            <div class="flex-grow basis-2/5 w-2/5"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center"></div>
            <div class="flex-grow basis-1/5 w-1/5 text-center">
            <span class="!text-sub !mb-0 break-words !font-medium mat-title">
              <ng-container *ngIf="equalToUsdAmount !== null">
                ( Equal to {{
                  equalToUsdAmount | smartCurrency:'USD':'':'code'
                }} )
              </ng-container>
            </span>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </section>

  </ng-container>
</div>
